import React, { useCallback } from 'react'

import { Table } from 'Components/Table'
import { Th } from 'Components/Table/Th'
import { Tr } from 'Components/Table/Tr'
import { authorization } from 'Module/Auth/Auth'

import H2HLocationRow from './H2HLocationRow'
import SortArrow from '../../../../../../Assets/Images/icons/sortArrow'
import { styles } from './styles'
const H2HLocationsTable = ({
  locations,
  changeSort,
  handleModalArchiveShow,
  handleModalEditShow,
  cityId,
  orderByColumn,
  orderByDirection,
}) => {
  const isCityManagerAssistant = authorization.isCityManagerAssistant()

  const getSortIcon = useCallback(
    column => {
      if (orderByColumn.column == column) {
        return orderByColumn.reverse ? (
          <SortArrow />
        ) : (
          <SortArrow style={{ transform: 'rotate(180deg)' }} />
        )
      }
      return null
    },
    [orderByColumn, orderByDirection],
  )

  const renderLabel = (label, columnName) => {
    return (
      <div style={styles.label}>
        {label}
        {columnName && getSortIcon(columnName)}
      </div>
    )
  }

  return (
    <Table>
      <thead>
        <Tr>
          <Th
            className="sortable"
            onClick={() => changeSort('name', orderByColumn)}
          >
            {renderLabel('Name', 'name')}
          </Th>
          <Th
            className="sortable"
            onClick={() => changeSort('type', orderByColumn)}
          >
            {renderLabel('Type', 'type')}
          </Th>
          <Th
            className="sortable"
            onClick={() => changeSort('deliveredFlyersNumber', orderByColumn)}
          >
            {renderLabel('Flyers distributed', 'deliveredFlyersNumber')}
          </Th>

          <Th
            className="sortable"
            onClick={() => changeSort('deliveredFlyer', orderByColumn)}
          >
            {renderLabel('Distribution rate', 'deliveredFlyer')}
          </Th>
          <Th
            className="sortable"
            onClick={() => changeSort('footTraffic', orderByColumn)}
          >
            {renderLabel('Foot Traffic', 'footTraffic')}
          </Th>
          <Th
            className="sortable"
            onClick={() => changeSort('scanRate', orderByColumn)}
          >
            {renderLabel('Scan Rate', 'scanRate')}
          </Th>
          <Th
            className="sortable"
            onClick={() => changeSort('conversionRate', orderByColumn)}
          >
            {renderLabel('Conversion Rate', 'conversionRate')}
          </Th>

          <Th className="sortable">{renderLabel('Status')}</Th>
          <Th className="align-right sortable">{renderLabel('Actions')}</Th>
        </Tr>
      </thead>
      <tbody>
        {locations.map(location => (
          <H2HLocationRow
            cityId={cityId}
            location={location}
            handleModalArchiveShow={handleModalArchiveShow}
            handleModalEditShow={handleModalEditShow}
            isCityManagerAssistant={isCityManagerAssistant}
          />
        ))}
      </tbody>
    </Table>
  )
}

export default H2HLocationsTable
